/**
 * Téléchargement d'un contenu renvoyé par l'API : binaire encodé base64 (PDF,
 * CSV…) OU texte brut (XML CIEL/STOCK, JSON VENDANGES).
 *
 * Source unique (DRY) de la mécanique « Blob → clic sur un lien temporaire →
 * révoque l'URL » utilisée par tous les exports (récap DRM/DS, registre, fiche
 * étiquette, fichiers de transmission). Les appelants ne diffèrent que par la
 * nature du contenu ; on extrait ici la seule logique commune sur des primitives.
 */

/** Mécanique commune : enveloppe un Blob dans un lien temporaire et le déclenche. */
function declencherTelechargement(blob: Blob, filename: string): void {
  const url = URL.createObjectURL(blob);
  const lien = document.createElement("a");
  lien.href = url;
  lien.download = filename;
  document.body.appendChild(lien);
  lien.click();
  lien.remove();
  URL.revokeObjectURL(url);
}

/** Déclenche le téléchargement navigateur d'un contenu base64 (binaire) sous `filename`. */
export function telechargerBase64(base64: string, mime: string, filename: string): void {
  const binaire = atob(base64);
  const octets = new Uint8Array(binaire.length);
  for (let i = 0; i < binaire.length; i += 1) {
    octets[i] = binaire.charCodeAt(i);
  }
  declencherTelechargement(new Blob([octets], { type: mime }), filename);
}

/** Déclenche un téléchargement direct depuis une URL signée de courte durée. */
export function telechargerUrlSignee(url: string): void {
  const lien = document.createElement("a");
  lien.href = url;
  lien.rel = "noopener noreferrer";
  document.body.appendChild(lien);
  lien.click();
  lien.remove();
}

/**
 * Déclenche le téléchargement navigateur d'un contenu TEXTE brut sous `filename`.
 * Contrairement au base64 (binaire à décoder), le fichier de transmission (XML
 * CIEL/STOCK, JSON VENDANGES) est déjà du texte : on l'enveloppe directement.
 */
export function telechargerTexte(contenu: string, mime: string, filename: string): void {
  declencherTelechargement(new Blob([contenu], { type: mime }), filename);
}
